<template>
    <veui-dialog
        theme="ai"
        title="意见反馈"
        :open="open"
        ui="wide"
        overlay-class="feedback-dialog"
        @cancel="handleCancel"
    >
        <veui-form
            ref="form"
            theme="ai"
            label-position="top"
            :data="formData"
            class="feedback-form"
        >
            <veui-field
                theme="ai"
                label="反馈类型"
                name="feedbackType"
                class="feedback-type"
                :rules="feedbackTypeRules"
            >
                <veui-radio-button-group
                    v-model="formData.feedbackType"
                    theme="ai"
                    ui="stable"
                    :items="typeList"
                />
            </veui-field>
            <veui-field
                theme="ai"
                label="问题描述"
                name="feedbackText"
                class="feedback-text"
                :rules="feedbackTextRules"
            >
                <veui-textarea
                    v-model="formData.feedbackText"
                    theme="ai"
                    placeholder="请输入您的建议和意见（500字以内）"
                    :maxlength="500"
                    strict
                />
            </veui-field>
            <veui-field
                theme="ai"
                label="相关图片"
                name="feedbackImages"
                class="feedback-images"
                :rules="feedbackImagesRules"
            >
                <uploader
                    v-model="formData.feedbackImages"
                    :max-count="MAX_IMAGES"
                    @snapshot="handleSnapshot"
                    @change="handleUpload"
                />
            </veui-field>
            <veui-field
                theme="ai"
                label="联系方式"
                name="contact"
                class="feedback-contact"
                :rules="feedbackContactRules"
            >
                <veui-input
                    v-model="formData.contact"
                    theme="ai"
                    placeholder="请输入邮箱或手机号码"
                />
            </veui-field>
        </veui-form>
        <template #foot>
            <div class="footer">
                <veui-button
                    theme="ai"
                    ui="m"
                    @click="handleCancel"
                >
                    取消
                </veui-button>
                <veui-button
                    theme="ai"
                    ui="m"
                    @click="handleClickFold"
                >
                    保存并收起
                </veui-button>
                <veui-button
                    theme="ai"
                    ui="m primary"
                    type="submit"
                    @click="handleSubmit"
                >
                    提交反馈
                </veui-button>
            </div>
        </template>
    </veui-dialog>
</template>

<script>
import {Dialog, Button, Form, Field, Textarea, Input, RadioButtonGroup} from 'veui';
import Uploader from './Uploader';
import {typeList} from './config';
import {nanoid} from 'nanoid';
import ScreenShot from 'js-web-screen-shot';
import {mapState, mapActions} from 'vuex';
import {cloneDeep} from 'lodash';

const MAX_IMAGES = 4;
export default {
    name: 'feedback', // 组件名称
    inject: ['$toast', 'model', 'alsLog'],
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button,
        'veui-form': Form,
        'veui-field': Field,
        'veui-textarea': Textarea,
        'veui-input': Input,
        'veui-radio-button-group': RadioButtonGroup,
        Uploader
    },
    props: {
        open: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            MAX_IMAGES,
            typeList,
            formData: {
                feedbackType: null,
                feedbackText: '',
                feedbackImages: [],
                contact: ''
            },
            feedbackTypeRules: [
                {name: 'required', triggers: 'blur', message: '未选择反馈类型'}
            ],
            feedbackTextRules: [
                {name: 'required', triggers: 'input,blur', message: '未填写问题描述'}
            ]

        };
    },
    watch: {
        feedbackFormData: {
            handler(val) {
                this.formData = cloneDeep(val);
            },
            immediate: true,
            deep: true
        }
    },
    computed: {
        ...mapState('feedback', ['feedbackFormData']),
        feedbackImagesRules() {
            return [
                {
                    name: 'imgaeValid',
                    value: this.formData.feedbackImages,
                    triggers: 'change',
                    // message: '单张照片大小不超过2M，格式为png、jpg、jpeg，最多4张',
                    validate(val) {
                        if (!val?.length) {
                            return true;
                        }
                        const imageType = ['jpg', 'jpeg', 'png'];
                        let flag = true;
                        val.forEach(item => {
                            const type = item.image_type?.split('/')?.[1];
                            const size = item.size;
                            if (!imageType.includes(type)) {
                                flag = false;
                            }
                            // 图片大小不能超过2M
                            if (size > 2 * 1024 * 1024) {
                                flag = false;
                            }
                        });
                        return flag;
                    }
                }
            ];
        },
        feedbackContactRules() {
            return [
                {name: 'required', triggers: 'input,blur', message: '未填写联系方式'},
                {
                    name: 'emailOrPhone',
                    value: this.formData.contact,
                    triggers: 'blur',
                    message: '联系方式填写错误',
                    validate(val) {
                        if (!val) {
                            return true;
                        }
                        const phoneReg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/g;
                        const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/g;
                        if (phoneReg.test(val) || emailReg.test(val)) {
                            return true;
                        }
                        return false;
                    }
                }
            ];
        }
    },
    methods: {
        ...mapActions('feedback', [
            'setFeedbackFormData',
            'resetFeedbackFormData',
            'submitFeedback'
        ]),
        clearValidate() {
            const formRef = this.$refs.form;
            formRef.clearValidities();
        },
        handleCancel() {
            this.clearValidate();
            this.resetFeedbackFormData();
            this.alsLog({
                f1: 'qingduoCancelFeedback',
                f2: 'click'
            });
            this.$emit('update:open', false);
        },
        handleClickFold() {
            this.fold();
            this.$toast.info('您的内容将仅暂存在当前网页下！');
            this.alsLog({
                f1: 'qingduoSaveAndCloseFeedback',
                f2: 'click'
            });
        },
        fold() {
            this.setFeedbackFormData(this.formData);
            this.$emit('update:open', false);
        },
        async handleSubmit() {
            const formRef = this.$refs.form;
            const valid = await formRef.validate();
            if (valid !== true) {
                return;
            }
            const {feedbackImages, feedbackText, ...rest} = this.formData;
            const formData = {
                ...rest,
                feedbackText: feedbackText.replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/&/g, '&amp;'),
                feedbackImages: feedbackImages.map(img => {
                    const base64Str = img.src?.split('base64,')?.[1];
                    return base64Str;
                })
            };
            this.fold();
            const logInfo = {
                feedbackType: this.formData.feedbackType,
                feedbackText: this.formData.feedbackText
            };
            this.alsLog({
                f1: 'qingduoFeedback',
                f2: 'submit',
                f6: JSON.stringify(logInfo)
            });
            try {
                await this.submitFeedback({
                    formData,
                    model: this.model
                });
                this.$toast.success('提交成功');
                // 清空表单
                this.resetFeedbackFormData();
            }
            catch (e) {
                console.log(e);
                this.$toast.error('提交失败');
            }
        },
        // 获取base64图片大小
        getBase64ImageSize(base64) {
            let str = atob(base64?.split(',')?.[1]);
            let bytes = str.length;
            return bytes;
        },
        snapshotComplete({base64}) {
            const img = {
                success: true,
                name: '',
                size: this.getBase64ImageSize(base64),
                image_type: 'image/png',
                src: base64,
                key: nanoid()
            };
            this.formData.feedbackImages.push(img);
            this.alsLog({
                f1: 'qingduoFeedbackImage',
                f2: 'click',
                f6: 'snapshot'
            });
            this.snapshotClose();
        },
        snapshotClose() {
            // 恢复页面滚动
            const app = document.getElementById('app');
            app.style.overflow = '';
            app.style.height = '100%';
            this.$emit('update:open', true);
        },
        handleSnapshot() {
            this.fold();
            const that = this;
            const clientWidth = document.documentElement.clientWidth;
            const clientHeight = document.documentElement.clientHeight;
            // 禁止页面滚动
            const app = document.getElementById('app');
            app.style.overflow = 'hidden';
            app.style.height = '100vh';

            new ScreenShot({
                enableWebRtc: true,
                level: 999,
                wrcWindowMode: true, // 启用窗口截图模式
                canvasWidth: clientWidth,
                canvasHeight: clientHeight,
                completeCallback: that.snapshotComplete,
                closeCallback: that.snapshotClose,
                cancelCallback: that.snapshotClose
            });
        },
        handleUpload() {
            this.alsLog({
                f1: 'qingduoFeedbackImage',
                f2: 'click',
                f6: 'upload'
            });
        }
    },
    mounted() {

    }
};
</script>

<style lang="less" scoped>
.feedback-dialog {
    /deep/ .veui-ai-dialog-content-head {
        padding-bottom: 24px;
    }
    /deep/ .veui-ai-dialog-content {
        width: 704px;
        border-radius: 16px;
    }
    /deep/ .veui-ai-dialog-content-foot {
        padding-top: 0;
    }
}
.feedback-form {
    /deep/ .veui-ai-field {
        width: 100%;
        .veui-ai-field-main {
            width: 100%;
        }
    }

    .feedback-type {
        /deep/ .veui-ai-button {
            &::before {
                background-color: transparent !important;
            }
        }
        /deep/ .veui-ai-field-main {
            flex-grow: 1;
            .veui-ai-field-content,.veui-ai-button-group,.veui-ai-radio-button-group-items {
                width: 100%;
            }
            .veui-ai-radio-button-group-items {
                display: flex;
                .veui-ai-button {
                    flex-grow: 1;
                }
                .veui-ai-button-native {
                    width: 84px;
                }
            }
        }
        /deep/ .veui-ai-button-selected>button {
            color: var(--AI-A7, var(--Brand-7, #3A5BFD));
        }
        /deep/ .veui-ai-button[ui~=m] {
            font-size: 14px;
            color: var(----G9, #282C33);
        }
    }
    /deep/ .veui-ai-field-label {
        height: 20px;
        margin-bottom: 8px;
        .veui-ai-field-required-symbol {
            margin-right: 0;
            color: #f53f3f;
        }
    }
    .feedback-text {
        width: 100%;
        /deep/ .veui-ai-field-main {
            flex-grow: 1;
            .veui-ai-field-content,.veui-ai-textarea {
                width: 100%;
            }
        }
        /deep/ .veui-ai-invalid {
            .veui-ai-textarea-count {
                color: #f53f3f;
            }
        }
        /deep/ .veui-ai-textarea-count {
            color: var(----T7, rgba(80, 90, 107, 0.80));
            background-color: transparent;
        }
    }

    .feedback-images {
        /deep/ &.veui-ai-invalid {
            .uploader-help {
                color: #D9150B;
            }
        }
        /deep/ .veui-ai-field-content-wrap {
            max-width: 656px;
            overflow: hidden;
        }

    }

}
.footer {
    display: flex;
    justify-content: flex-end;
}
</style>
